import { render } from "./BuildIcon5.vue?vue&type=template&id=95af33a2&scoped=true"
import script from "./BuildIcon5.vue?vue&type=script&lang=js"
export * from "./BuildIcon5.vue?vue&type=script&lang=js"

import "./BuildIcon5.vue?vue&type=style&index=0&id=95af33a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95af33a2"]])

export default __exports__